import type { ReviewStatusCounts } from "./progressSegments";

export function progressBarLabel(counts: ReviewStatusCounts): string {
  const released = counts.readyForRelease;
  const approved = counts.readyForEditing;
  const pending = counts.pending;

  if (released === 0 && approved === 0 && pending === 0) {
    return "No content reviewed yet";
  }

  return `${released} Released, ${approved} Approved, ${pending} Pending`;
}
